module.exports = __webpack_public_path__ + "static/media/comp-sorting-s.638448bb.webp";